export const API_URL = `${process.env.REACT_APP_API_URL}/api`;
export const BASE_URL = process.env.REACT_APP_API_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;

export const DEFAULT_COUNTRY = {
  name: 'Ireland',
  dial_code: '+353',
  code: 'IE',
};

export const BASE_ADYEN_CONFIG = {
  locale: 'en_US',
  environment: process.env.REACT_APP_ADYEN_ENV,
  clientKey: process.env.REACT_APP_ADYEN_KEY,
};

export const NOVA_URL = `${BASE_URL}/admin`;
